import { Button } from "./DesignSystem/Button/Button";
import Modal from "./DesignSystem/Modal/Modal";

type SlackIntegrationConfirmModalProps = {
  show: boolean;
  onOpenChange: () => void;
  slackUrl: string;
};

export const SlackIntegrationConfirmModal = ({
  show,
  onOpenChange,
  slackUrl,
}: SlackIntegrationConfirmModalProps) => {
  return (
    <Modal.Root open={show} onOpenChange={onOpenChange}>
      <Modal.Content
        size="small"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <Modal.Header>
          <Modal.Title>Get Alerts on Slack</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-flex t-flex-col t-gap-4 t-text-text-60 t-h-[163px]">
            <div className=" t-text-subtitle-sm">How it works?</div>
            <div className="t-text-body-sm tracking-[0.1px]">
              <ul>
                <li>
                  Receive chat notifications of all your unread messages on
                  Slack
                </li>
                <li>
                  Send a quick reply to te latest message by replying to the
                  alert on Slack
                </li>
                <li>
                  Never mis important messages on your tax deadline and filings
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="t-flex t-justify-end t-gap-3">
          <Button customType="secondary" size="regular" onClick={onOpenChange}>
            Cancel
          </Button>
          <a href={slackUrl} className="t-no-underline">
            <Button customType="primary" size="regular">
              Connect
            </Button>
          </a>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
